import React, { useContext, useState } from 'react';
import {
    Grid,
    DialogContent,
    Dialog,
    DialogActions,
    DialogTitle,
    Button,
    TextField,
    Container,
} from '@material-ui/core'
import clsx from 'clsx';
import Alert from '@material-ui/lab/Alert';

import ChallengeContext from '../../../../context/challenge-context'
import { editTeamMember } from '../../../../actions/challenge-actions';
import useStyles from '../../../../styles/components/rewards/stylesRewardShop';

const EditTeamMemberDialog = ({ _handleClose, _studentNumber, _memberId }) => {

    const classes = useStyles();
    const [studentNumber, setStudentNumber] = useState(_studentNumber);
    const { challengeContext, dispatch } = useContext(ChallengeContext);

    function checkMemberId(member) {
        return member.MemberId === _memberId;
    }

    const handleUpdate = async () => {
        let editMember = { MemberId: _memberId, StudentNumber: studentNumber, ChallengeId: challengeContext.challenge.ChallengeId };
        let response = await editTeamMember(JSON.stringify(editMember));
        if (response > 200 || response.status === "Failed") {
            setAlert('Update failed for some reason.', 'error')
        }
        if (response.status === "Success") {
            let index = challengeContext.challenge.TeamMemberViewModels.findIndex(checkMemberId);
            challengeContext.challenge.TeamMemberViewModels[index].StudentNumber = studentNumber;
            dispatch({ type: 'SET_CHALLENGE', challenge: challengeContext.challenge });
            setAlert('Update success.', 'success')
        }
    };

    const setAlert = (message, severity) => {
        challengeContext.alert.severity = severity;
        challengeContext.alert.message = message;
        dispatch({ type: 'SET_ALERT', alert: challengeContext.alert });
    }

    const handleChange = (event, label) => {
        switch (label) {
            case "studentNumber": setStudentNumber(event.target.value)
                break;
        }
    }

    const handleClose = () => {
        setStudentNumber('');
        setAlert('', '');
        _handleClose();
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth='md'
            open={true}
            classes={{
                root: classes.rootDialogConfirm,
                paper: classes.paperDialogConfirm,
            }}
        >
            <DialogTitle disableTypography={true} style={{ fontSize: '20px' }} classes={{ root: classes.rootDialogConfirmTitle }}>
                Edit Student Number
            </DialogTitle>
            {
                challengeContext.alert.message.length > 0 ?
                    <>
                        <DialogContent classes={{ root: classes.rootDialogConfirmContent }}>
                            <Alert style={{ margin: "10px" }} variant="outlined" severity={challengeContext.alert.severity}>
                                {challengeContext.alert.message}
                            </Alert>
                        </DialogContent>
                        <DialogActions classes={{ root: classes.rootDialogActions }}>
                            <Button onClick={handleClose} className={clsx(classes.buttonDialogConfirm, classes.buttonYes)}>
                                Ok
                            </Button>
                        </DialogActions>
                    </>
                    :
                    <>
                        <DialogContent classes={{ root: classes.rootDialogConfirmContent }}>
                            <Container style={{ margin: '5px' }}>
                                <Grid container alignItems="center" style={{ marginTop: '10px' }}>
                                    <TextField
                                        fullWidth
                                        color="secondary"
                                        required
                                        label="Student Number"
                                        variant="outlined"
                                        value={studentNumber}
                                        onChange={event => handleChange(event, 'studentNumber')}
                                    />
                                </Grid>
                            </Container>
                        </DialogContent>
                        <DialogActions classes={{ root: classes.rootDialogActions }}>
                            <Button onClick={handleClose} className={clsx(classes.buttonDialogConfirm, classes.buttonCancle)}>
                                Cancel
                            </Button>
                            <Button onClick={handleUpdate} className={clsx(classes.buttonDialogConfirm, classes.buttonYes)}>
                                Update
                            </Button>
                        </DialogActions>
                    </>
            }
        </Dialog>
    );
};

export default EditTeamMemberDialog;